import { useQuery } from '@tanstack/react-query';

import { fetchSignupTerms } from '@/api/adapters/signup';
import type { SignupTerm } from '@/features/auth/types/signup-terms';

/**
 * Fetch published signup terms for the given invitation token.
 * React Query hook — replaces manual useEffect + useState pattern.
 */
export function useSignupTerms(token: string) {
  return useQuery<SignupTerm[], Error>({
    queryKey: ['signupTerms', token],
    queryFn: () => fetchSignupTerms(token),
    staleTime: 5 * 60 * 1000, // 5 min — terms rarely change mid-session
  });
}
